import { useMemo } from "react";
import { useGetProduceTypes } from "../../../../../api/static-data";
import IngredientInfoTile from "./IngredientInfoTile";

interface IngredientProduceTilesProps {
  produceType?: string | number;
  produceCultivar?: string;
  farmingType?: string;
  fieldType?: string;
  countryName?: string;
}

const IngredientProduceTiles = ({
  produceType,
  produceCultivar,
  farmingType,
  fieldType,
  countryName
}: IngredientProduceTilesProps) => {
  const { data: produceTypesData, isSuccess: isProduceTypesSuccess } = useGetProduceTypes();

  const produceTypes = useMemo(() => {
    if (isProduceTypesSuccess) {
      return produceTypesData?.map((p: any) => ({
        text: p.produce_name,
        key: p.id,
        value: p.id
      }));
    }
  }, [produceTypesData, isProduceTypesSuccess]);

  const produceTypeName = produceTypes?.find(
    (p: any) => parseInt(p.value) === parseInt(produceType as string)
  )?.text;

  return (
    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-3">
      <IngredientInfoTile label="Produce Type" value={produceTypeName} />
      <IngredientInfoTile label="Produce Cultivar" value={produceCultivar} />
      <IngredientInfoTile label="Farming Type" value={farmingType} />
      <IngredientInfoTile label="Field Type" value={fieldType} />
      <IngredientInfoTile label="Country" value={countryName} />
    </div>
  );
};

export default IngredientProduceTiles;
